<script lang="ts">
    import ColorPicker from "svelte-awesome-color-picker";
    import { _ } from "svelte-i18n";
    import { ModalHook } from "./ModalHook";
    import { appManager } from "../../AppManager";
    import { get, writable } from "svelte/store";

    const hook = new ModalHook<
        { color: string; visualizationType?: string },
        "cancelled" | { color: string; visualizationType?: string }
    >();
    appManager.ModalHooks.TripsLayerSettingsModal = hook;

    let isOpen = writable(false);
    let useSafetyScore: boolean = false;
    let hex = hook.getData()?.color ?? "#000000";
    hook.on("open", () => {
        const data = hook.getData();
        hex = data?.color ?? "#000000";
        useSafetyScore = data.visualizationType === "bicycle.safety";
        isOpen.set(true);
    });
    hook.on("close", () => isOpen.set(false));
    let maxWidth = 330;

    const close = () => {
        hook.close("cancelled");
    };

    const ok = () => {
        let visualizationType: string = undefined;
        if (useSafetyScore) {
            visualizationType = "bicycle.safety";
        }
        hook.close({ color: hex, visualizationType: visualizationType });
    };
</script>

{#if $isOpen}
    <div class="modal show" style="display: block;">
        <div class="modal-dialog modal-lg" style="max-width: {maxWidth}px;">
            <div class="modal-content">
                <div class="modal-body p-6">
                    <button
                        type="button"
                        class="btn-close"
                        aria-label="Close"
                        on:click={close}
                    />

                    <!-- <h2 class="font-weight-bold text-center mb-1">
                        
                    </h2> -->
                    <div class="flex flex-column h-100">
                        <ColorPicker
                            bind:hex
                            isOpen={true}
                            isAlpha={false}
                            isDialog={false}
                            disableCloseClickOutside={true}
                        />

                        <div class="row">
                            <div class="col-12">
                                <div class="list-group list-group-flush">
                                    <div class="list-group-item">
                                        <div class="row align-items-center">
                                            <div class="col">
                                                <p class="mb-0">
                                                    {$_(
                                                        "modals.triplayersettings.safetyscore.title",
                                                    )}
                                                </p>
                                                <small class="text-gray-700">
                                                    {$_(
                                                        "modals.triplayersettings.safetyscore.description",
                                                    )}
                                                </small>
                                            </div>
                                            <div class="col-auto">
                                                <div
                                                    class="form-check form-switch"
                                                >
                                                    <input
                                                        class="form-check-input"
                                                        type="checkbox"
                                                        id="switchOne"
                                                        bind:checked={useSafetyScore}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="d-grid gap-2">
                                    <button
                                        class="btn btn-block btn-primary mt-3"
                                        on:click={ok}
                                    >
                                        {$_("modals.triplayersettings.ok")}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
{/if}
